var __default__ = {root:'m_3eebeb36',label:'m_9e365f20'};
export default __default__;